const { debounce } = window.BAO.Utils

export class CartNote extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this,
      'change',
      debounce(e => window.BAO.Cart.updateNote(e.target.value), 500),
    )
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote)
}
